import React, { useState } from "react";

const AskedQuestion = () => {
  const faqImages = [
    "/images/faq/faq-1-1.jpg",
    "/images/faq/faq-1-2.jpg",
  ];

  const faqs = [
    {
      question: "What documents do I need to rent a car?",
      answer:
        "Aqestic optio amet a ququam saepe aliquid voluate dicta fuga dolor saerror sed earum a magni soluta quam minus dolor dolor sed earum a magni soluta autem dolor error error sit.",
    },
    {
      question: "What age do I need to be to rent a car?",
      answer:
        "Aqestic optio amet a ququam saepe aliquid voluate dicta fuga dolor saerror sed earum a magni soluta quam minus dolor dolor sed earum a magni soluta autem dolor error error sit.",
    },
    {
      question: "How do I clean and maintain wallpaper?",
      answer:
        "Aqestic optio amet a ququam saepe aliquid voluate dicta fuga dolor saerror sed earum a magni soluta quam minus dolor dolor sed earum a magni soluta autem dolor error error sit.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(1);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section
      className="asked-question section-space-top asked-question--padding-bottom"
      id="faq"
    >

      {/* Background */}
      <div
        className="asked-question__bg"
        style={{
          backgroundImage:
            "url('/images/shapes/asked-bg.png')",
        }}
      ></div>

      {/* Top Images */}
      <div className="container-fluid">

        <div
          className="asked-question__carousel wow fadeInLeft"
          data-wow-duration="1500ms"
          data-wow-delay="300ms"
        >

          <div className="row g-4">

            {faqImages.map((image, index) => (
              <div className="col-lg-6 col-md-6" key={index}>

                <div className="faq-one__carousel__item">
                  <img
                    src={image}
                    alt={`FAQ ${index + 1}`}
                    className="img-fluid rounded"
                  />
                </div>

              </div>
            ))}

          </div>

        </div>

      </div>

      {/* FAQ Section */}
      <div className="container">

        <div className="row gutter-y-40">

          <div className="col-lg-6 ms-auto">

            {/* Title */}
            <div className="sec-title sec-title--two text-start">

              <h6 className="sec-title__tagline bw-split-in-right">
                ASKED QUESTION
              </h6>

              <h3 className="sec-title__title bw-split-in-left">
                We Care Of Your Safety <br />
                And Convenience
              </h3>

            </div>

            {/* Accordion */}
            <div
              className="faq-page__accordion wow fadeInRight"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >

              {faqs.map((faq, index) => (
                <div
                  className={`accrodion mb-3 ${
                    activeIndex === index ? "active" : ""
                  }`}
                  key={index}
                >

                  {/* Title */}
                  <div
                    className="accrodion-title d-flex justify-content-between align-items-center p-3"
                    onClick={() => toggleAccordion(index)}
                    style={{
                      cursor: "pointer",
                      background: "#f5f5f5",
                      borderRadius: "6px",
                    }}
                  >

                    <h4 className="accrodion-title__text mb-0">
                      <span className="accrodion-title__icon me-2"></span>
                      {faq.question}
                    </h4>

                    <span>
                      {activeIndex === index ? "-" : "+"}
                    </span>

                  </div>

                  {/* Content */}
                  {activeIndex === index && (
                    <div className="accrodion-content p-3 border">

                      <div className="inner">
                        <p className="inner__text mb-0">
                          {faq.answer}
                        </p>
                      </div>

                    </div>
                  )}

                </div>
              ))}

            </div>

          </div>

        </div>

      </div>

      {/* Decorative Shape */}
      <div className="asked-question__element">
        <img
          src="/images/shapes/shape-faq.png"
          alt="Shape"
        />
      </div>

    </section>
  );
};

export default AskedQuestion;